import { useContext } from 'react';

import { ToggleSwitch } from '../../../../../components/toggle-switch';
import {
  RISK_METRIC_LIST,
  TIME_LIST,
  VOL_SHOCK_LIST,
} from '../../../../../constants/reports/reports-filters';
import { PortfolioManagementContext } from '../../../../../providers/portfolio-management';
import { useRiskSettings } from '../../../hooks/risk/use-risk-settings';

import { PortfolioRiskSettingsItem } from './portfolio-risk-settings-item';

import './styles.scss';

export const PortfolioSidebarSettingsRisk = () => {
  const { setRiskSettingsSelected, riskSettingsSelected } = useContext(PortfolioManagementContext);

  const VOL_SHOCK_DEFAULT =
    riskSettingsSelected?.volShocks.length > 0
      ? VOL_SHOCK_LIST.filter((volShock) =>
          riskSettingsSelected.volShocks.includes(Number(volShock.value)),
        )
      : VOL_SHOCK_LIST.filter((volShock) => volShock.value === '0');

  const TIMES_DEFAULT =
    riskSettingsSelected?.times.length > 0
      ? TIME_LIST.filter((time) => riskSettingsSelected.times.includes(time.value))
      : TIME_LIST.filter((time) => time.value === '0D');

  const RISK_METRICS_DEFAULT = RISK_METRIC_LIST.filter((metrics) =>
    riskSettingsSelected?.riskMetrics.length > 0
      ? metrics.isRiskSettings &&
        !metrics.disabled &&
        riskSettingsSelected?.riskMetrics.includes(metrics.value)
      : metrics.isRiskSettings && !metrics.disabled,
  ).sort((a, b) => a.label.localeCompare(b.label));

  const volShocks = useRiskSettings(setRiskSettingsSelected, 'volShocks', VOL_SHOCK_DEFAULT);
  const times = useRiskSettings(setRiskSettingsSelected, 'times', TIMES_DEFAULT);
  const riskMetrics = useRiskSettings(setRiskSettingsSelected, 'riskMetrics', RISK_METRICS_DEFAULT);

  const handleShowRiskCharts = (value: boolean) => {
    setRiskSettingsSelected((prevState) => ({
      ...prevState,
      showRiskCharts: value,
    }));
  };

  return (
    <div className="portfolio-sidebar-settings-risk-container">
      <div className="portfolio-sidebar-settings-risk-header">
        <h2>Risk settings</h2>
        <span>
          New settings will not be applied to existing calculations, only when you recalculate.
        </span>
      </div>

      <div className="portfolio-sidebar-settings-risk-selects">
        <div className="portfolio-risk-settings-toggle-area">
          <ToggleSwitch
            isOn={riskSettingsSelected?.showRiskCharts}
            setIsOn={handleShowRiskCharts}
          />
          <span>Show risk charts</span>
        </div>
        <div>
          <PortfolioRiskSettingsItem
            itemTitle="Vol shocks"
            items={VOL_SHOCK_LIST.filter((vs) => !vs.isDefault)}
            handleChange={volShocks.handleChange}
            selectedItems={volShocks.selectedItems}
          />
          <PortfolioRiskSettingsItem
            itemTitle="Time"
            items={TIME_LIST.filter((time) => !time.isDefault)}
            selectedItems={times.selectedItems}
            handleChange={times.handleChange}
          />
          <PortfolioRiskSettingsItem
            itemTitle="Risk Metric"
            items={RISK_METRIC_LIST}
            selectedItems={riskMetrics.selectedItems}
            handleChange={riskMetrics.handleChange}
          />
        </div>
      </div>
    </div>
  );
};
